"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTodaysResponse = void 0;
var date_fns_1 = require("date-fns");
var findTodaysResponse = function (responses) {
    if (responses && responses.length) {
        var todaysResponse = responses[0];
        if (date_fns_1.isToday(new Date(todaysResponse.createdAt))) {
            return todaysResponse;
        }
    }
    return null;
};
exports.findTodaysResponse = findTodaysResponse;
